/**
 * @generated SignedSource<<3b442f70d52b95ae365c11a07f6eb1ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationICAScreenMutation$variables = Record<PropertyKey, never>;
export type IntegrationICAScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationICAMinButikInitiate: {
      readonly integration: {
        readonly authRequests: ReadonlyArray<{
          readonly expiresAtDate: {
            readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
          } | null;
          readonly link: string | null;
        }> | null;
      } | null;
      readonly url: string;
    } | null;
  };
};
export type IntegrationICAScreenMutation = {
  response: IntegrationICAScreenMutation$data;
  variables: IntegrationICAScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationICAScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MinButikInitiateResponse",
            "kind": "LinkedField",
            "name": "activateIntegrationICAMinButikInitiate",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ICAMinButikIntegration",
                "kind": "LinkedField",
                "name": "integration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ICAMinButikAuthRequest",
                    "kind": "LinkedField",
                    "name": "authRequests",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "expiresAtDate",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StoreFormattedDate"
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationICAScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MinButikInitiateResponse",
            "kind": "LinkedField",
            "name": "activateIntegrationICAMinButikInitiate",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ICAMinButikIntegration",
                "kind": "LinkedField",
                "name": "integration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ICAMinButikAuthRequest",
                    "kind": "LinkedField",
                    "name": "authRequests",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "expiresAtDate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "style",
                                "value": "DEFAULT"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "storeFormattedDate",
                            "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b04412c70d4796c65644ad61c5e2ed3e",
    "id": null,
    "metadata": {},
    "name": "IntegrationICAScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationICAScreenMutation {\n  store {\n    activateIntegrationICAMinButikInitiate {\n      url\n      integration {\n        authRequests {\n          expiresAtDate {\n            ...StoreFormattedDate\n          }\n          link\n        }\n      }\n    }\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n"
  }
};
})();

(node as any).hash = "ac619814257b89f4284d7349371383ad";

export default node;
